import { Link } from 'react-router-dom';
import { Trophy, X } from 'lucide-react';
import { useState } from 'react';

export default function ContestBanner() {
  const [isVisible, setIsVisible] = useState(true);

  if (!isVisible) return null;

  return (
    <div 
      className="fixed left-0 right-0 bg-gradient-to-r from-purple-600 via-pink-500 to-orange-500 text-white py-2.5 px-4 overflow-hidden"
      style={{ 
        top: 'calc(3.5rem + env(safe-area-inset-top, 0px))',
        zIndex: 10000 
      }}
    >
      <div className="absolute inset-0 bg-[url('data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNDAiIGhlaWdodD0iNDAiIHZpZXdCb3g9IjAgMCA0MCA0MCIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48ZyBmaWxsPSJub25lIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiPjxjaXJjbGUgY3g9IjIwIiBjeT0iMjAiIHI9IjIiIGZpbGw9InJnYmEoMjU1LDI1NSwyNTUsMC4xKSIvPjwvZz48L3N2Zz4=')] opacity-30"></div>
      
      <Link 
        to="/contest" 
        className="container mx-auto flex items-center justify-center gap-2 relative z-10 hover:opacity-90 transition-opacity"
      >
        <Trophy className="w-4 h-4 md:w-5 md:h-5 animate-bounce text-yellow-300" />
        <span className="font-bold text-xs md:text-sm tracking-wide animate-pulse">
          🎉 SOUNDOPE'S HAVING A CONTEST!! 🎉
        </span>
        <span className="hidden sm:inline text-xs md:text-sm opacity-90">
          — Win $100 & get featured!
        </span>
        <Trophy className="w-4 h-4 md:w-5 md:h-5 animate-bounce text-yellow-300" />
      </Link>

      <button 
        onClick={(e) => {
          e.preventDefault();
          e.stopPropagation();
          setIsVisible(false);
        }}
        className="absolute right-2 top-1/2 -translate-y-1/2 p-1 hover:bg-white/20 rounded-full transition-colors z-20"
        aria-label="Close banner"
      >
        <X className="w-4 h-4" />
      </button>
    </div>
  );
}
